export class SystemRoles {
    FilterBySport: boolean;
    ClientSiteURL: boolean;
}



// WEBPACK FOOTER //
// ./src/services/settings/settings.model.ts